export enum Roles {
  admin = 'ADMIN',
  professional = 'PROFESSIONAL',
  user = 'USER',
  organization_admin = 'ORGANIZATION_ADMIN',
  organization_owner = 'ORGANIZATION_OWNER',
}

export enum Categories {
  veterinarian = 'veterinarian',
  dietitian = 'dietitian',
  behaviorist = 'behaviorist',
  physiotherapist = 'physiotherapist',
}
